module.exports = __webpack_public_path__ + "static/media/validation_operation.27014c8e.gif";